import { validatorStringTextOnly } from "./validatorStringTextOnly";
// import { getOptionalMinLengthTest } from "./getOptionalMinLengthTest";

// const VALIDATOR_NAME_MIN_LENGTH = 2;

// const testMinLengthIfNotEmpty = getOptionalMinLengthTest(
//   VALIDATOR_NAME_MIN_LENGTH,
//   `Should be at least ${VALIDATOR_NAME_MIN_LENGTH} characters`
// );

// export const validatorName = validatorStringTextOnly.test(
//   testMinLengthIfNotEmpty
// );

export const validatorName = validatorStringTextOnly;
